import { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { useT } from '@/store/i18n';

interface ConfirmOptions {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}

let resolver: ((v: boolean) => void) | null = null;
let setOpenExt: ((opts: ConfirmOptions | null) => void) | null = null;

export function confirmDialog(opts: ConfirmOptions): Promise<boolean> {
  if (!setOpenExt) {
    // Component not mounted yet — fall back to native confirm so the call
    // never silently fails.
    return Promise.resolve(window.confirm(opts.title + (opts.description ? '\n\n' + opts.description : '')));
  }
  return new Promise((res) => {
    resolver = res;
    setOpenExt!(opts);
  });
}

export function ConfirmDialogHost() {
  const t = useT();
  const [opts, setOpts] = useState<ConfirmOptions | null>(null);
  setOpenExt = setOpts;

  const close = (v: boolean) => {
    resolver?.(v);
    resolver = null;
    setOpts(null);
  };

  return (
    <Modal
      open={!!opts}
      onClose={() => close(false)}
      title={opts?.title}
      description={opts?.description}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={() => close(false)}>
            {opts?.cancelLabel ?? t('btn.cancel')}
          </Button>
          <Button
            variant={opts?.destructive ? 'danger' : 'primary'}
            onClick={() => close(true)}
            autoFocus
          >
            {opts?.confirmLabel ?? t('btn.confirm')}
          </Button>
        </>
      }
    >
      <div className="text-sm text-slate-600 leading-relaxed">
        {t('confirm.irreversible')}
      </div>
    </Modal>
  );
}
